import React from "react";
import ReactDOM from "react-dom";

import App from "routes/App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { store } from "Reducer/Reducer";
import { LayoutProvider } from "routes/LayoutContext";
import { BreakpointProvider } from "./components/Breakpoint/Breakpoint";
import { ThemeProvider, createGlobalStyle } from "styled-components";
import { lighten } from "polished";
import "assets/styles/styles.module.scss";

const GlobalStyle = createGlobalStyle`
  body, html {
    background-color: ${({ theme, layoutMode, type }) => {
      return theme.Primary;
    }};
    background: ${({ theme, layoutMode, type }) => {
      return theme.Primary;
    }};
  }
  .btn {
    color: ${(props) => props.theme.Primary};;
    border-color: #D9D9D9;
    background-color: transparent;
    &:focus {
      outline: none;
    }
    &:hover {
      background-color: ${(props) => props.theme.Primary};
      border-color: ${(props) => props.theme.Primary};
      color: ${(props) => props.theme.ActionElement};
    }
    &.btn-primary {
      color: ${(props) => props.theme.ActionElement};
      background-color: ${(props) => props.theme.Primary};
      border-color: ${(props) => props.theme.Primary};
      &:hover:not([disabled]) {
        background-color: ${(props) => lighten(0.15, props.theme.Primary)};
        border-color: transparent;
      }
    }
    &.btn-secondary {
      color: ${(props) => props.theme.ActionElement};
      background-color: ${(props) => props.theme.Secondary};
      border-color: ${(props) => props.theme.Secondary};
      &:hover {
        background-color: ${(props) => lighten(0.05, props.theme.Secondary)};
        border-color: transparent;
        color: ${(props) => props.theme.Primary};
        border-color: ${(props) => props.theme.Primary};
      }
    }
    &.btn-round {
      border-radius: 40px;
    }
    
  }
  .ErrorText {
    color: #ff0000;
    display: flex;
    align-items: center;
    transition: opacity 300ms ease-in-out;
    display: block;
    margin-top: 5px;
    font-size: 14px;
    align-content: center;
  }
`;

const Theme = {
  TWD: {
    Primary: "#14212A",
    Secondary: "#DBDDFF",
    Tertiary: "",
    Divider: "#232766",
    ActionBtn: "#EC1E24",
    ActionBtnSplash: "#FA7578",
    ActionElement: "#29E7D6",
  },
  default: {
    Primary: "#14212A",
    Secondary: "#DBDDFF",
    Tertiary: "",
    Divider: "#232766",
    ActionBtn: "#EC1E24",
    ActionBtnSplash: "#FA7578",
    ActionElement: "#FFFFFF",
  },
};

const getTheme = (currency) => {
  let themeObject = Theme[currency] ? Theme[currency] : Theme.default;

  if (!themeObject.ActionElementOpacity) {
    themeObject.ActionElementOpacity = 1;
  }
  themeObject.breakpoints = [
    "374px",
    "479px",
    "575px",
    "767px",
    "991px",
    "1199px",
    "1599px",
  ];
  themeObject.breakpoints.ss = themeObject.breakpoints[0];
  themeObject.breakpoints.xs = themeObject.breakpoints[1];
  themeObject.breakpoints.sm = themeObject.breakpoints[2];
  themeObject.breakpoints.md = themeObject.breakpoints[3];
  themeObject.breakpoints.lg = themeObject.breakpoints[4];
  themeObject.breakpoints.xl = themeObject.breakpoints[5];
  themeObject.breakpoints.xxl = themeObject.breakpoints[6];

  return themeObject;
};

const queries = {
  ss: "(max-width: 374px)",
  xs: "(max-width: 479px)",
  sm: "(max-width: 575px)",
  md: "(max-width: 767px)",
  lg: "(max-width: 991px)",
  xl: "(max-width: 1199px)",
  xxl: "(max-width: 1599px)",
};

ReactDOM.render(
  <Provider store={store}>
    <BreakpointProvider queries={queries}>
      <LayoutProvider>
        <ThemeProvider theme={getTheme("TWD")}>
          <GlobalStyle />
          <App />
        </ThemeProvider>
      </LayoutProvider>
    </BreakpointProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
